module.exports = __webpack_public_path__ + "img/modelo_small10.0626ecc1.png";